import * as React from 'react';
import {HotKeys} from "react-hotkeys";

import "./radioButton.scss";

const classNames = require('classnames');
const uuidv4 = require('uuid/v4');

export interface RadioButtonOption {
	/**
	 * Label for radio button.
	 */
	label: string;
	/**
	 * Radio button value.
	 */
	value: string;
	/**
	 * Radio button disable flag.
	 */
	disabled: boolean;
}

interface Props {
	/**
	 * Radio button options list.
	 */
	radioButtonOption: RadioButtonOption;
	/**
	 * On change callback.
	 * @param {string} value
	 */
	onChange: (value: string) => void;
	/**
	 * Value of selected element.
	 */
	selected: boolean;
}

export default class RadioButton extends React.Component<Props, {}> {

	/**
	 * Unique radios name.
	 */
	inputRadiosName = uuidv4();

	/**
	 * Hot keys map.
	 */
	hotKeysMap = {
		onEnter: 'enter'
	};

	/**
	 * Hot keys handlers
	 */
	hotKeysHandlers: any;

	constructor(props: Props) {
		super(props);
		this.hotKeysHandlers = {
			onEnter: () => this.props.onChange(this.props.radioButtonOption.value)
		}
	}

	render() {
		const classFromProps = classNames({
			"a-radio-button": true,
			"is-disabled": this.props.radioButtonOption.disabled,
		});

		return (
			<HotKeys keyMap={this.hotKeysMap} handlers={this.hotKeysHandlers}>
				<div className={classFromProps}>
					<label tabIndex={0}>
						<input type="radio" name={this.inputRadiosName}
							   tabIndex={-1}
							   value={this.props.radioButtonOption.value}
							   checked={this.props.selected}
							   onChange={evt => this.props.onChange(evt.currentTarget.value)}/>
						{this.props.radioButtonOption.label}
						<span/>
					</label>
				</div>
			</HotKeys>
		);
	}
}